import * as Flux from 'dg-web-shared/lib/Flux.tsx';
import { Maybe } from 'dg-web-shared/lib/MaybeV2.ts';

export interface State {
    selectedPermitExternalId: Maybe<string>;
    selectedClearanceExternalId: Maybe<string>;
}

export enum PermitSlideInConfirmation {
    terminate,
}

export class StateSlice extends Flux.StateSlice<State> {
    key(): string {
        return 'clearance-permit-list-ClearancePermitListState';
    }
    sideEffects(): void {
        return;
    }

    getInitialState(): State {
        return {
            selectedPermitExternalId: null,
            selectedClearanceExternalId: null,
        };
    }

    selectPermit(contractExternalId: string | null): void {
        this.set((s: State): State => {
            s.selectedPermitExternalId = contractExternalId;
            return s;
        });
    }

    selectClearance(contractExternalId: string | null): void {
        this.set((s: State): State => {
            s.selectedClearanceExternalId = contractExternalId;
            return s;
        });
    }
}

export enum SelectedTab {
    Search,
    FilteredPermits,
    FilteredClearances,
    ClearanceRequests,
}
export namespace Layout {
    export interface State {
        selectedTab?: SelectedTab;
    }
    export const { get, reset, stateWrite } = Flux.generateState<State>(
        'clearance-permit-list-ClearancePermitListState.Layout',
        {
            selectedTab: SelectedTab.Search,
        },
    );
}
